import type { CookieService } from "@/src/infrastructure/cookie-consent/CookieService";

import { sections } from "@/src/infrastructure/cookie-consent/CookieCategory";
import { language as defaultLanguage } from "@/src/infrastructure/i18n";

export const language = {
  default: defaultLanguage,
  translations: {
    [defaultLanguage]: {
      consentModal: {
        acceptAllBtn: "Tout accepter",
        acceptNecessaryBtn: "Tout refuser",
        description:
          "Ils sont utilisés pour faciliter la navigation et l’expérience sur notre site (par exemple, pour visionner une vidéo).",
        footer: "",
        showPreferencesBtn: "Je choisis",
        title: "Pas de lait équitable sans cookies 🍪",
      },
      preferencesModal: {
        acceptAllBtn: "Tout accepter",
        acceptNecessaryBtn: "Tout refuser",
        closeIconLabel: "Fermer",
        savePreferencesBtn: "Enregistrer mes préférences",
        sections,
        serviceCounterLabel: "service|services",
        title: "Mes préférences en matière de cookies 🍪",
      },
    },
  },
};

export function iframeLanguages(
  service: CookieService,
  noticePrefix: string,
): unknown {
  return {
    [defaultLanguage]: {
      loadAllBtn: "Toujours accepter",
      loadBtn: "Accepter cette fois",
      notice: `${noticePrefix}, accepter les cookies ${service.name}`,
    },
  };
}

export const showPreferencesLabel = "Gestion des cookies";
